import { serializeJsonLd } from '../../utils/jsonLd';

/**
 * Renders one JSON-LD structured-data block.
 *
 * The dangerouslySetInnerHTML here is safe BY CONSTRUCTION: the payload is
 * always produced by serializeJsonLd (JSON.stringify + `<` escaped to <),
 * so no value — including attacker-influenced listing text — can close the
 * script tag or introduce markup. Never bypass the serializer.
 */
export default function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
    />
  );
}
